import { isAdobeFontStylesheetUrl } from "@hightouch/lib/brand-profiles/assets/adobe-fonts";

export const HOSTED_FONT_STYLESHEET_IMPORT =
  /^\s*@import\s+url\(["']?([^"'\s)]+)["']?\)\s*;\s*$/i;

export function hostedFontStylesheetUrls(
  fontRules: readonly string[],
): string[] {
  const urls = new Set<string>();
  for (const rule of fontRules) {
    const match = HOSTED_FONT_STYLESHEET_IMPORT.exec(rule);
    if (!match?.[1]) {
      continue;
    }
    if (!isAdobeFontStylesheetUrl(match[1])) {
      throw new Error(
        "Font stylesheet isn't supported. Update the font in Context Hub.",
      );
    }
    urls.add(match[1]);
  }
  return [...urls];
}
